// extracted by mini-css-extract-plugin
export var label = "_ds-2";
export var slideContainer = "_ds-0";
export var slider = "_ds-1";